import { api } from "./api";
import { AxiosError, AxiosResponse } from 'axios';
import { AuthBodyType } from "./types";

export type ClientType = {
  id?: string;
  contato: string;
  dataAlteracao?: number;
  dataCadastro: number;
  empresa: string;
  nome: string;
  locais?: string[];
  listaGerencia?: string[];
  responsavel: string;
  status: string;
  tags?: string[];
  foto: string;
  tiposServico?: string[] | undefined,
};

export type ClientsWithChildren = {
  id: string,
  status: string,
  nome: string,
  locaisList: {
    id: string,
    nome: string,
    conjuntosList: {
      id: string,
      nome: string
    }[]
  }[]
};

export interface IdNameObj {
  id: string,
  nome: string
}

export interface conjuntosList extends IdNameObj {
  unidadesList: IdNameObj[]
}
export interface locaisList extends IdNameObj {
  conjuntosList: conjuntosList[]
}
export interface HierarchyForWebForm extends IdNameObj {
  locaisList: locaisList[],
  message?: string,
}

class Clients {


  getAllClients = async (body: AuthBodyType, inclusiveInativos: boolean) => {
    try {
      const data: AxiosResponse = await api.post("/clientes/getList", {
        ...body,
        inclusiveInativos,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  createClient = async (body: AuthBodyType, customer: ClientType) => {
    try {
      const data: AxiosResponse = await api.post("/clientes/newCliente", {
        ...body,
        cliente: customer,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  updateClient = async (body: AuthBodyType, customer: ClientType) => {
    try {
      const data: AxiosResponse = await api.post("/clientes/updateCliente", {
        ...body,
        cliente: customer,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);

        return error.response?.status;
      }
    }
  };

  createClientTag = async (body: AuthBodyType & { tag: string }) => {
    try {
      const data: AxiosResponse = await api.post("/clientes/createClientTags", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        throw new Error(error.message);
      }
    }
  };
  getClientTag = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/clientes/getClientTags", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        throw new Error(error.message);
      }
    }
  };

  deleteClientTag = async (body: AuthBodyType & { tagId: string }) => {
    try {
      const data: AxiosResponse = await api.post("/clientes/deleteClientTag", {
        ...body,
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        throw new Error(error.message);
      }
    }
  };

  getAllWithSets = async (body: AuthBodyType, tipoServico: string) => {
    try {
      const data: AxiosResponse = await api.post("/clientes/getAllWithSets", {
        ...body,
        tipoServico
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        throw new Error(error.message);
      }
    }
  };

  addServiceType = async (body: AuthBodyType, tiposServico: string[], cliente: string) => {
    try {
      const data: AxiosResponse = await api.post("/clientes/addTipoServico", {
        ...body,
        tiposServico,
        cliente
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        throw new Error(error.message);
      }
    }
  };

  getListForWebForm = async (body: AuthBodyType, formId: string) => {
    try {
      const data: AxiosResponse = await api.post("/clientes/getListForWebForm", {
        ...body,
        formId
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        throw new Error(error.message);
      }
    }
  };

  getAllHierarchy = async (body: AuthBodyType) => {
    try {
      const data: AxiosResponse = await api.post("/clientes/getAllHierarchy", {
        ...body
      });
      return data.data;
    } catch (err) {
      const error = err as Error | AxiosError;
      if (error instanceof AxiosError) {
        console.error(error.message);
        console.log("erro --->", error);
        throw new Error(error.message);
      }
    }
  };
}

export default Clients;
